import type {
  DashboardQuickAccessItem,
  DashboardStatCard,
} from '@/modules/Dashboard/types/model'

export const DASHBOARD_STAT_CARDS: DashboardStatCard[] = [
  {
    id: 'unread-letters',
    title: 'نامه‌های خوانده نشده',
    value: 0,
    icon: 'secretariat',
    accentColor: '#DC2626',
    waveColor: '#FEE2E2',
  },
  {
    id: 'letters-in-circulation',
    title: 'نامه‌های در گردش',
    value: 0,
    icon: 'secretariat',
    accentColor: '#BD7A28',
    waveColor: '#FFF4E6',
  },
  {
    id: 'today-reminders',
    title: 'یادآوری‌های امروز',
    value: 0,
    icon: 'calendarClock',
    accentColor: '#0D9488',
    waveColor: '#CCFBF1',
  },
  {
    id: 'unread-articles',
    title: 'مقالات خوانده نشده',
    value: 0,
    icon: 'graduationCap',
    accentColor: '#2563EB',
    waveColor: '#DBEAFE',
  },
]

export const DASHBOARD_QUICK_ACCESS_ITEMS: DashboardQuickAccessItem[] = [
  {
    id: 'announcements',
    label: 'اطلاعیه‌ها',
    icon: 'promotion',
    iconColor: '#9333EA',
    action: 'navigate',
    to: '/news',
  },
  {
    id: 'educational-content',
    label: 'محتوای آموزشی',
    icon: 'graduationCap',
    iconColor: '#2563EB',
    action: 'navigate',
    to: '/article',
  },
  {
    id: 'create-letter',
    label: 'ایجاد نامه',
    icon: 'secretariat',
    iconColor: '#BD7A28',
    action: 'navigate',
    to: '/secretariat/create',
  },
  {
    id: 'colleague-evaluation',
    label: 'ارزشیابی همکاران',
    icon: 'fileSearch',
    iconColor: '#6B9408',
    action: 'navigate',
    to: '/evaluation/assigned',
  },
  {
    id: 'create-reminder',
    label: 'ایجاد یادآور',
    icon: 'calendarClock',
    iconColor: '#DC2626',
    action: 'navigate',
    to: '/reminder',
  },
]

export const EVALUATION_TOAST_MESSAGE = 'این بخش به‌زودی در دسترس خواهد بود'

export const DASHBOARD_ANNOUNCEMENT_EMPTY_BODY =
  'اعلان جدیدی برای نمایش وجود ندارد.'

export const DASHBOARD_NOTIFICATIONS_EMPTY_MESSAGE = 'اعلانی وجود ندارد'

export const DASHBOARD_REMINDERS_EMPTY_MESSAGE =
  'یادآوری برای این روز ثبت نشده است.'

export const DASHBOARD_CALENDAR_SECTION_TITLE = 'تقویم یادآورها'

export const DASHBOARD_CALENDAR_BACK_TO_TODAY_LABEL = 'بازگشت به امروز'
